export default __webpack_public_path__ + "Staudt_UMETRICS_Employee_Profile_Report_Disclosure_Memo_2019_Q2_Public_2.pdf";